import { render, staticRenderFns } from "./BatchOperateBindVD.vue?vue&type=template&id=cb00591a&scoped=true"
import script from "./BatchOperateBindVD.vue?vue&type=script&lang=ts"
export * from "./BatchOperateBindVD.vue?vue&type=script&lang=ts"
import style0 from "./BatchOperateBindVD.vue?vue&type=style&index=0&id=cb00591a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb00591a",
  null
  
)

export default component.exports